import { connectedStore } from '../../store';
import actions from '../actions';

const hide = (modalProps) => {
  const store = connectedStore.get();

  store.dispatch(actions.hide(modalProps));
};

export default hide;
